import { render, staticRenderFns } from "./page-1.vue?vue&type=template&id=13b4f2fb&scoped=true&"
import script from "./page-1.vue?vue&type=script&lang=js&"
export * from "./page-1.vue?vue&type=script&lang=js&"
import style0 from "./page-1.vue?vue&type=style&index=0&id=13b4f2fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4f2fb",
  null
  
)

export default component.exports